export default "__VITE_ASSET__0c1ba77b__"